import type { ScreeningExclusion } from "../bookingFlowMachine"
import { screeningExclusionHeading, screeningExclusionText } from "../screeningCopy"
import { Box, Button, Typography } from "@carrotfertility/carotene-core"
import React from "react"

type NotEligiblePageProps = {
  // Set when screening disqualified the member; absent if reached without a recorded reason.
  exclusion?: ScreeningExclusion | null
  onBackToHome?: () => void
}

// TEMPORARY (OPS-9280): placeholder disqualification page — heading, layout, and back-to-home
// action are stand-ins pending real design for what a screened-out member sees.
export function NotEligiblePage({ exclusion, onBackToHome }: NotEligiblePageProps): JSX.Element {
  // "" falls through to the default exclusion copy when no reason was recorded.
  const heading = screeningExclusionHeading(exclusion?.emergency ?? false)
  const message = screeningExclusionText(exclusion?.exclusionMessageId ?? "")

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.md),
        maxInlineSize: 640
      })}
    >
      <Typography variant="h1">{heading}</Typography>
      <Typography>{message}</Typography>
      <Box>
        <Button onClick={onBackToHome} color="secondary">
          Back to home
        </Button>
      </Box>
    </Box>
  )
}
